import React, { useState, useEffect } from 'react'
import { CapacityModel } from '../capacity.model'
import { Typography, useTheme, makeStyles, Button, List, ListItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCube } from '@fortawesome/free-solid-svg-icons'
import { styles } from './editBundle.styles'
import { useHistory } from 'react-router-dom'
import Page, { PageLayout } from '../../../components/page/page'
import PageLeftColumn from '../../../components/page/pageLeftColumn'
import PageCenterColumn from '../../../components/page/pageCenterColumn'
import PageRightColumn from '../../../components/page/pageRightColumn'
import PageHeader from '../../../components/page/pageHeader'
import { Allocations } from '../forms/allocations'
import { EnumBloqueoCapacidad } from '../../../api'
import { NonAuthRoutes } from '../../../model'
import { getCapacityItem } from '../capacity.service'
import { FormSkeleton } from '@globaleris/ui.library'
import { useHttpError } from '../../../hooks/useHttpError'
import { AddendumsCard } from './addendum/addendumCard'

export const EditCapacityBundlePage: React.FC<any> = props => {
  let history = useHistory()
  const [t] = useTranslation(['capacity', 'enums'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const [capacity, setCapacity] = useState<CapacityModel | undefined>(undefined)

  const { showError, clearError, errorProps } = useHttpError()

  useEffect(() => {
    const fetchCapacity = async (id: number) => {
      await getCapacityItem(id).then(response => {
        if (response.success) {
          clearError()
          setCapacity(response.data)
        } else {
          showError({
            title: t('capacity:forms.editBundle.title'),
            errorCode: response.error!.code,
            actions: [
              {
                label: t('capacity:forms.editBundle.mainActions.back'),
                onClick: () => {
                  history.push(NonAuthRoutes.capacity)
                },
                default: true
              }
            ],
            onRefresh: () => fetchCapacity(id)
          })
        }
      })
    }

    if (props.location.state) {
      fetchCapacity(props.location.state.idCapacity)
    } else {
      history.push(NonAuthRoutes.capacity)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Page layout={PageLayout.MULTI_COLUMN} error={errorProps}>
      <PageLeftColumn>
        {capacity ? (
          <>
            <Typography variant="h1" color="primary" noWrap={true}>
              {capacity?.code}{' '}
              <FontAwesomeIcon
                icon={faCube}
                color={currentTheme.palette.primary.main}
              ></FontAwesomeIcon>
            </Typography>

            <List className={classes.resume}>
              <ListItem disableGutters>
                <Typography variant={'h2'}>{capacity?.translatedService}</Typography>
              </ListItem>
              <ListItem disableGutters>
                <Typography variant={'body2'}>{capacity?.logisticElement?.description}</Typography>
              </ListItem>
              <ListItem disableGutters>
                <Typography variant={'body2'}>{capacity?.formattedCapacity} kWh/día</Typography>
              </ListItem>
              <ListItem divider disableGutters>
                <Typography variant={'body2'}>
                  {capacity?.formattedInitDate} - {capacity?.formattedEndDate}
                </Typography>
              </ListItem>
              <ListItem divider disableGutters>
                <Typography variant={'caption'}>
                  {t('capacity:forms.editFormalized.labels.duration')}
                </Typography>
                <Typography variant={'subtitle2'}>{capacity?.translatedDuration}</Typography>
              </ListItem>
              <ListItem divider disableGutters>
                <Typography variant={'caption'}>
                  {t('capacity:forms.editFormalized.labels.rawMaterial')}
                </Typography>
                <Typography variant={'subtitle2'}>{capacity?.formattedRawMaterial}</Typography>
              </ListItem>
              <ListItem divider disableGutters>
                <Typography variant={'caption'}>
                  {t('capacity:forms.editFormalized.labels.nature')}
                </Typography>
                <Typography variant={'subtitle2'}>{capacity?.translatedNature}</Typography>
              </ListItem>
              <ListItem divider disableGutters>
                <Typography variant={'caption'}>
                  {t('capacity:forms.editFormalized.labels.premium')}
                </Typography>
                <Typography variant={'subtitle2'}>{capacity?.formattedPremium} kWh/dia</Typography>
              </ListItem>
              <ListItem divider disableGutters>
                <Typography variant={'caption'}>
                  {t('capacity:forms.editFormalized.labels.signDate')}
                </Typography>
                <Typography variant={'subtitle2'}>{capacity?.formattedSignDate}</Typography>
              </ListItem>
            </List>
          </>
        ) : (
          <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={9}></FormSkeleton>
        )}
      </PageLeftColumn>
      <PageCenterColumn>
        <PageHeader title={t('capacity:forms.editBundle.title')}>
          <Button
            className={classes.cardAction}
            size="small"
            color="primary"
            onClick={() => history.push(NonAuthRoutes.capacity)}
          >
            {t('capacity:forms.editBundle.mainActions.back')}
          </Button>
        </PageHeader>
        <Allocations
          canSend={true}
          canEdit={capacity?.lockState !== EnumBloqueoCapacidad.BloqueadoUsuario}
          data={capacity?.allocations}
        ></Allocations>
        <AddendumsCard addendums={capacity?.addendums} />
      </PageCenterColumn>
      <PageRightColumn></PageRightColumn>
    </Page>
  )
}
